import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import AppButton from '../../components/AppButton';

import WrapperContent from './WrapperContent';
import PhoneInput from 'react-phone-input-2';
import WrapperContainerFields from '../../components/WrapperContainerFields';
import api from '../../services/api';
import {Form, Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {addNotification} from '../../redux/actions';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {STORAGE} from '../../enviroment';
import Text from '../../components/fields/Text';
import {FormControl, InputLabel, Select as MatSelect, alpha} from '@material-ui/core';
import {listado} from '../../util/listado';

const validationSchema = yup.object().shape({
  first_name: yup.string().required('Nombre es requerido.'),
  last_name: yup.string().required('Nombre es requerido.'),
  email: yup.string().required('E-Mail es requerido.'),
  phone_country_code: yup.string().required('Telefono es requerido.'),
});

const useStyles = makeStyles((theme) => ({
  link: {
    color: 'blue',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  textField: {
    width: '100%',
  },
  formControl: {
    width: '100%',
  },
  textFieldStreet: {
    width: 150,
  },
  title: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(2),
  },
}));

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: '1px solid #e2e2e1',
    overflow: 'hidden',
    borderRadius: 4,
    backgroundColor: '#fcfcfb',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: '#fff',
    },
    '&$focused': {
      backgroundColor: '#fff',
      boxShadow: `${alpha(theme.palette.primary.main, 0.2)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const Data = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.auth.user);
  const classesReddit = useStylesReddit();

  const saveData = async ({first_name, last_name, email, phone, phone_country_code}) => {
    await api.users
      .patch(data.id, {
        first_name,
        last_name,
        email,
        phone,
        phone_country_code,
      })
      .then(() => {
        dispatch(addNotification('Usuario actualizado', 'success'));
      })
      .catch((error) => {
        dispatch(addNotification(error.message, 'error'));
      });
  };

  function logout() {
    STORAGE.clear();
    dispatch({type: 'SET_RESET'});
    window.location.href = '/';
  }

  return (
    <WrapperContent>
      <Formik
        initialValues={data}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={saveData}
        render={({values, handleChange, handleSubmit, setFieldValue}) => (
          <Form
            onKeyPress={(event) => {
              event.key === 'Enter' && handleSubmit();
            }}
          >
            <WrapperContainerFields>
              <Grid item xs={12} md={4}>
                <Text name={'first_name'} label="Nombre" value={values.first_name} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} md={4}>
                <Text name={'last_name'} label="Apellido" value={values.last_name} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} md={4}>
                <Text name={'email'} label="Correo electrónico" value={values.email} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} md={4}>
                <PhoneInput
                  specialLabel={''}
                  masks={{co: '(...) ... ....'}}
                  value={`${values.phone_country_code}${values.phone}`}
                  country={values.phone_country_code}
                  name="phone"
                  onChange={(phone, country) => {
                    setFieldValue('phone', phone);
                    setFieldValue('phone_country_code', country.dialCode);
                  }}
                  inputStyle={{
                    width: '100%',
                    border: '1px solid #e2e2e1',
                    backgroundColor: '#fcfcfb',
                    height: 58,
                  }}
                  containerStyle={{
                    width: '100%',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                {/* <label id='customer_type' style={{ marginBottom: 6 }}>A que sector perteneces</label> */}
                <Box mb={2}>
                  <FormControl fullWidth variant="filled">
                    <InputLabel htmlFor="filled-age-native-simple">Selecciona a que sector perteneces</InputLabel>
                    <MatSelect
                      native
                      disableUnderline
                      className={classesReddit.root}
                      value={values.customer_type}
                      defaultValue={values.customer_type}
                      onChange={(event) => {
                        setFieldValue('customer_type', event.target.value);
                      }}
                    >
                      <option aria-label="None" value="">
                        Selecciona a que sector perteneces
                      </option>
                      {Object.entries(listado).map(([category, items]) => (
                        <optgroup label={category} key={category}>
                          {items.map((item, index) => (
                            <option value={`${category}-${item}`} key={`${category}-${index}`}>
                              {item}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </MatSelect>
                  </FormControl>
                </Box>
              </Grid>
            </WrapperContainerFields>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Box display="flex" justifyContent="flex-start" mt={4} mb={3}>
                  <div className={classes.link} onClick={logout}>
                    Cerrar Sesión
                  </div>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box display="flex" justifyContent="flex-end" mt={4} mb={3}>
                  <AppButton round onClick={handleSubmit} variant="contained" color="secondary">
                    Guardar cambios
                  </AppButton>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      />
    </WrapperContent>
  );
};

export default Data;
